import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface ManageUsersFiltersProps {
  search: string;
  status: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
}

export const ManageUsersFilters = ({ search, status, onSearchChange, onStatusChange }: ManageUsersFiltersProps) => {
  return (
    <div className="mt-6 flex flex-col gap-4 md:flex-row">
      <div className="flex-1">
        <Input
          theme="new"
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by surname, name or email..."
        />
      </div>
      <div className="w-full md:w-64">
        <Select value={status} onValueChange={onStatusChange}>
          <SelectTrigger>
            <SelectValue placeholder="All Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="pending_invite">Pending invite</SelectItem>
            <SelectItem value="invited_pending_signup">Invited — pending signup</SelectItem>
            <SelectItem value="registered_pending_onboarding">Registered — onboarding pending</SelectItem>
            <SelectItem value="registered_onboarded">Active — onboarding complete</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
